import client from '../lib/http-client';

const endpoint = 'http://localhost:3000/atem';

export default {

	// Create category
	execute(params, cb, errorCb) {
		const responseHandler = (response) => {
			if (cb) cb(response.data);
		};
		const errorHandler = (e) => {
			if (errorCb) errorCb(e);
		};
		const url = `${endpoint}/execute`;
		client.post(url, params)
			.then(responseHandler)
			.catch(errorHandler);
	},
	checkConnection(cb, errorCb) {
		const url = `${endpoint}/check`;

		const responseHandler = (response) => {
			if (cb) cb(response.data);
		};
		const errorHandler = (e) => {
			if (errorCb) errorCb(e);
		};
		client.get(url)
			.then(responseHandler)
			.catch(errorHandler);
	},
};
